import CloseIcon from 'Components/Icons/CloseIcon';
import { TOKEN, deleteCaseApi, generateSignedurlApi, generateSignedurlForDocsApi, getCaseDetailsApi, getGeminiResponseApi, raiseNotificationApi, removeDocumentApi, revertApprovalApi, updateCaseDetailsApi, updateDocumentsApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import DocumentsSection from './DocumentsSection';
import AdditionalInfoEdit from './AdditionalInfoEdit';
import RequiredInfo from './RequiredInfo';
import AdditionalFields from './AdditionalFields';
import AreYouSureModal from 'Modals/AreYouSureModal';
import InfoIcon from 'Components/Icons/InfoIcon';
import { FaRegCopy } from "react-icons/fa6";
import CaseDeletedModal from 'Modals/CaseDeletedModal';
import { GiProgression } from "react-icons/gi";

import PreApprovedContentOnDetails from './PreApprovedContentOnDetails';
import { getCaseType, getNetWorth } from 'Utils';
import AiIntegration from 'Components/AiIntegration/AiIntegration';
import AiInsightsLoading from 'Components/AiIntegration/AiInsightsLoading';
import ScaleOneToTen from 'Components/Element/ScaleOneToTen';
import { MdCallReceived } from 'react-icons/md';
import { IoArrowRedo } from 'react-icons/io5';
import { ChevronDown } from 'lucide-react';
import { TbListDetails } from 'react-icons/tb';
import CaseDetailsHeader from './CaseDetailsHeader';
import CaseDetailsStepper from './CaseDetailsStepper';
import CaseDetailsExtraInfo from './CaseDetailsExtraInfo';
import CaseDetailsInformation from './CaseDetailsInformation';
import { toast } from 'react-toastify';
import CaseInfoTabs from './CaseInfoTabs';
import CaseDetailsToggleTile from './CaseDetailsToggleTile';
import CaseAdditionalInfo from './CaseAdditionalInfo';

function  CaseBaseInfo({id}) {
    const [caseDetails, setCaseDetails] = useState(null);
    
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const [updateComp, setUpdateComp] = useState(false);
    const [additionalFields, setAdditionalFields] = useState({});
    const [loadingFirms, setLoadingFirms] = useState(false);
    // AI insights still not done after we stopped checking (~3 min) - the
    // loading view then offers "Check again" instead of spinning forever
    const [insightsStalled, setInsightsStalled] = useState(false);
    const [maxDocuments, setMaxDocuments] = useState(10);
    const [copied, setCopied] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [showTrackerSection, setShowTrackerSection] = useState(true);
    const [showCaseDetails, setShowCaseDetails] = useState(true);
    const {trackerSectionRef} = useRef();
    const {caseDetailsRef} = useRef();
    const location = useLocation();
    // Default to AI Insights (2) on case load; "?tab=details" (e.g. Review from the
    // "Needs you" list on the cases page) opens Case Details (1), where the requests are.
    const [currentTab, setCurrentTab] = useState(new URLSearchParams(location.search).get('tab') === 'details' ? 1 : 2);
    const [currentStep, setCurrentStep] = useState(0);
    const [contentStep, setContentStep] = useState(0);
    const navigate = useNavigate();
    const [isCaseOpen, setIsCaseOpen] = useState(true);
    const [noOfInterests, setNoOfInterests] = useState(0);
    const requestPopupRef = useRef(null);
    const MAX_DOC_SIZE = 10 * 1024 * 1024; // 10MB
    const MAX_VIDEO_SIZE = 150 * 1024 * 1024; // 150MB

    const validateFiles = (files, name) => {
    const fileArr = Array.from(files);

    if (name === "videoDocument") {
        if (fileArr.length > 1) {
        toast.error("Please choose one video only.");
        return false;
        }

        if (fileArr[0].size > MAX_VIDEO_SIZE) {
        toast.error("Video size too large (max 150MB)");
        return false;
        }
    }
    else if(name === "supportingDocuments")
    {
        if(files.length > maxDocuments)
        {
            toast.error(`You can only upload upto 10 documents in total.`);
            return;
        }
        for (let file of fileArr) {
        if (file.size > MAX_DOC_SIZE) {
        toast.error(`File too large: ${file.name}`);
        return false;
        }
        }
    }
    
    return true;
    };
    const handleCopy = () => {  
        navigator.clipboard.writeText(caseDetails?.caseNumber);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    const deleteCase = () => {
       makeApiCallFunc(
        deleteCaseApi,
        { id: id },
        ({data})=>
        {
            setShowModal(false);
            navigate("/client/cases");
            console.log(data)
        },
        function (error) {
            console.log(error)
        }
       )
    }
    
    const uploadDocuments = (e, name) => {
        const files = e.target.files;

        
        if(validateFiles(files, name))
        {
            uploadedFileUrl(e.target.files, name);
        }
    }
    const generateFilesArray = (files) => {
       
       const fileArr =  Array.from(files);
        let arr = []
        fileArr.map((file)=>{
            arr.push({fileName: file.name, fileType: file.type})
        });
        return arr;
    }
   const uploadToSignedUrls = async (urlObj, files, name) => {
    const fileArr = Array.from(files);

    try {
        await Promise.all(
        urlObj.map(async (url, index) => {
            const file = fileArr[index];

            const res = await fetch(url.location, {
            method: "PUT",
            headers: {
                "Content-Type": file.type,
            },
            body: file,
            });

            if (!res.ok) {
            throw new Error(`Upload failed: ${file.name}`);
            }
        })
        );

        // only after ALL uploads succeed
        makeApiCallFunc(
        updateDocumentsApi + "/" + id,
        {
            [name]: urlObj,
            documentTypeName: name,
        },
        () => setUpdateComp(prev => !prev),
        (err) => console.log(err)
        );

    } catch (err) {
        console.error("Upload error:", err);
    }
    };
    const uploadedFileUrl = async (supportingDocuments, name) => {
           const arr = generateFilesArray(supportingDocuments);
           // caseId is required now - the server uses it to namespace the S3
           // key (previously two uploads sharing a filename could collide)
           // and to check the caller actually owns this case before handing
           // out an S3 write URL.
           makeApiCallFunc(generateSignedurlForDocsApi,
              {files: arr, caseId: id},
              ({data}) => {
                uploadToSignedUrls(data?.url,supportingDocuments, name);
              },
              (data) => { console.log(data) }
            );
       
      }

    const removeDoc = (fileName, updatedPostData, callback = () => {}) =>{
        makeApiCallFunc(
            removeDocumentApi,
            {
                fileName: fileName,
                updatedPostData: updatedPostData,
                id: id
            },
            (data) => {
                setUpdateComp(prev => !prev);
                callback();
                toast.success(fileName + " Document removed successfully");
            },
            (data) => console.log(data)
        )
    }
    const aggregateList = (data) => {
        let noOfInterest = 0;
        let modifiedResponse = {
            "requested":[],
            "denied":[],
            "approved":[],
            "noConflict":[],
            "conflict":[],
            "reqToClose":[],
            "closed":[] 
        };
        const reqToCloseTeamupIds = data?.userCase?.find((entry) => entry?.caseStatus === "reqToClose")?.teamup?.fromUser ? data?.userCase?.find((entry) => entry?.caseStatus === "reqToClose")?.teamup : null;
        const closedTeamupIds = data?.userCase?.find((entry) => entry?.caseStatus === "closed")?.teamup?.fromUser ? data?.userCase?.find((entry) => entry?.caseStatus === "closed")?.teamup : null;

        data.userCase.map((entry) => {
         if(entry?._id)
         {
            noOfInterest = noOfInterest + (entry?.deniedCount? entry?.deniedCount : 1);
            //if there is teamup i need to ignore that entry here and prefer teamup obj over
            if(entry.caseStatus === "noConflict" && entry?.teamup )//successful teamup and no conflict entry and should be same as closeid or reqtocloseid
            {
                //check if this entry user id is part of teamup ids of closed or req to close
                if((reqToCloseTeamupIds && (entry?.userId?._id === reqToCloseTeamupIds?.fromUser?._id || entry?.userId?._id === reqToCloseTeamupIds?.toUser?._id)) ||
                   (closedTeamupIds && (entry?.userId?._id === closedTeamupIds?.fromUser?._id || entry?.userId?._id === closedTeamupIds?.toUser?._id))
                   )
                {
                    //then return null to avoid duplicate entry
                    return null;
                }
            }
            return modifiedResponse[entry.caseStatus]?.push(entry)
         }
         else
            {
                return null;
            }
        });
        setCurrentStep(getStatusOfCase(modifiedResponse));
        setContentStep(getStatusOfCase(modifiedResponse, true));
        setNoOfInterests(noOfInterest);

        return modifiedResponse;
    }
    const getStatusOfCase = (data, prefReq = false) => {
        let status = 1;
        if(prefReq && data["requested"].length !== 0)
        {
            return 2;
        }
        if(data["closed"].length !== 0)
        {
            setIsCaseOpen(false);
            return 6;

        }
        if(data["reqToClose"].length !== 0)
        {
            return 5;
        }
        if(data["noConflict"].length !== 0)
        {
            return 4;
        }
        if(data["approved"].length !== 0)
        {
            return 3;
        }
        if(data["requested"].length !== 0)
        {
            return 2;
        }
        return status;
    }
   

    useEffect(() => {
        let cleanupPolling;
        makeApiCallFunc(
            getCaseDetailsApi+'/'+id,
            null,
            ({data})=>
            {   
                console.log(data);

                if(!data?.is_deleted)
                {
                    setCaseDetails({...data, "userCase" : aggregateList(data)});
                    if(data?.aiPartyResearchStatus === 1 || data?.aiValuationStatus === 1 || data?.aiFirmMatchStatus === 1)
                    {
                        // keep the cancel function so polling stops when the client leaves this page
                        setInsightsStalled(false);
                        cleanupPolling = pollingFunc(data);
                    }
                    setMaxDocuments(data?.supportingDocuments?.length === 0 ? 10 : 10 - data?.supportingDocuments?.length);
                    setAdditionalFields(data?.additionalFields ? JSON.parse(data?.additionalFields) : {})
                }
                else
                {
                    setCaseDetails(data);
                }
                },
            function (error) {
               
                console.log(error);
            }
        )
        return () => {
            if (cleanupPolling) {
                cleanupPolling();
            }
        };
    },[updateComp])
    // Research->valuation and firm-match are independent chains now (see
    // server/routes/case.js) - each can reach a terminal state on its own
    // timeline, so this tracks them separately instead of stopping on
    // whichever completes first (which used to cut polling short for the
    // other one, silently freezing it mid-progress in the UI until the user
    // manually refreshed the page).
    const fetchGemini = (caseDetails, mergedState) => {
    console.log("inside poll function 4")

        return new Promise((resolve) => {
        makeApiCallFunc(
            getGeminiResponseApi+"/"+caseDetails?._id,
            null,
            ({data}) => {
            console.log("Gemini polling data:", data);

            const estimateChainDone =
                data.aiPartyResearchStatus === 3 ||
                data.aiValuationStatus === 2 ||
                data.aiValuationStatus === 3;
            const firmMatchDone =
                data.aiFirmMatchStatus === 2 || data.aiFirmMatchStatus === 3;

            // getGeminiResponseApi only returns status flags, not the actual
            // results - as soon as either chain newly reaches a terminal
            // state, pull the full case once and merge it in directly so
            // that chain's real data (e.g. aiLocalFirms/aiSmallFirms) shows
            // up right away, without waiting for the other chain too. This
            // deliberately does NOT go through setUpdateComp - that would
            // re-trigger the effect that originally started this polling
            // loop and spawn a second, overlapping one.
            const needsFirmMerge = firmMatchDone && !mergedState.firmMerged;
            const needsEstimateMerge = estimateChainDone && !mergedState.estimateMerged;
            if (needsFirmMerge || needsEstimateMerge) {
                if (needsFirmMerge) mergedState.firmMerged = true;
                if (needsEstimateMerge) mergedState.estimateMerged = true;
                makeApiCallFunc(
                    getCaseDetailsApi + '/' + caseDetails?._id,
                    null,
                    ({data: fullData}) => {
                        if (!fullData?.is_deleted) {
                            setCaseDetails(prev => prev ? { ...prev, ...fullData, "userCase": aggregateList(fullData) } : prev);
                        }
                    },
                    (error) => console.error("Error refreshing case details mid-poll:", error),
                    null,
                    true
                );
            }

            if (estimateChainDone && firmMatchDone) {
                // both chains have finished (success or failure) - stop polling
                setLoadingFirms(false);
                if (data.aiPartyResearchStatus === 3 || data.aiValuationStatus === 3) {
                    toast.error("AI estimate generation failed. Please try again.");
                }
                resolve(true); // stop polling
            }
            else {
                resolve(false); // keep polling - at least one chain still running
            }
            },
            (error) => {
            console.error("Error fetching Gemini response:", error);
            resolve(false);
            },
            null,
            true
        );
        });
    };

const pollingFunc = (caseDetails) => {
    console.log("inside pill function")
    let cancelled = false;
    // let interval;
    let attempts = 0;
    // every 5s for up to 3 minutes (insights usually take ~40-90s; 10 tries
    // = 50s used to stop too early and leave the page loading until a refresh)
    const maxAttempts = 36;
    // Tracks whether each chain's full result has already been merged in
    // (see fetchGemini above) - seeded from whatever's already true on the
    // snapshot this loop started with, so a chain that was already done
    // when polling began isn't re-fetched pointlessly on the first tick.
    const mergedState = {
        firmMerged: caseDetails?.aiFirmMatchStatus === 2 || caseDetails?.aiFirmMatchStatus === 3,
        estimateMerged:
            caseDetails?.aiPartyResearchStatus === 3 ||
            caseDetails?.aiValuationStatus === 2 ||
            caseDetails?.aiValuationStatus === 3,
    };
    const sleep = (ms) =>
    new Promise(resolve => setTimeout(resolve, ms));
   const startPolling = async () => {
        if (caseDetails?.aiPartyResearchStatus !== 1 && caseDetails?.aiValuationStatus !== 1 && caseDetails?.aiFirmMatchStatus !== 1) {
            return;
        }

        for (let attempts = 0; attempts < maxAttempts; attempts++) {
            if (cancelled) {
                return;
            }

            const shouldStop = await fetchGemini(caseDetails, mergedState);

            console.log(
                `Polling attempt ${attempts + 1}: ${
                    shouldStop ? "Stopping" : "Continuing"
                }`
            );

            if (shouldStop || cancelled) {
                return;
            }

            if (attempts < maxAttempts - 1) {
                await sleep(5000);
            }
        }

        // Maximum attempts reached
        setLoadingFirms(false);
        if (!cancelled) setInsightsStalled(true);
    };

    startPolling();

    // Cleanup function
    return () => {
        cancelled = true;
    };
  };
  return (
    <>
    {
        showModal &&
        <AreYouSureModal
        uploadNew= {showModal}
         onClose={()=> setShowModal(false)}
         onSubmit = {deleteCase}
        />
    }
    {
        caseDetails && !caseDetails?.is_deleted ?
        <div className='w-full  h-full'>
            <CaseDetailsHeader caseDetails={caseDetails} />
             <CaseInfoTabs currentTab={currentTab} setCurrentTab={setCurrentTab}/>
             {
                currentTab === 1 ?
                <>
                <CaseDetailsStepper
                    caseDetails={caseDetails}
                    setUpdateComp={setUpdateComp}
                    currentStep={currentStep}
                    contentStep={contentStep}
                    setContentStep={setContentStep}
                    requestPopupRef={requestPopupRef}
                    />
                
                    {/* on phones the tiles get a side gutter instead of running edge to edge */}
                    <div className='px-3 lg:px-0 pb-6 lg:pb-0'>
                    {!caseDetails?.status  &&
                        <PreApprovedContentOnDetails
                        setUpdateComp={setUpdateComp}
                        updateComp={updateComp}
                        caseDetails={caseDetails}
                        />
                    }
                    {showCaseDetails &&

                <>
                <CaseAdditionalInfo
                caseDetails={caseDetails}
                uploadDocuments={uploadDocuments}
                removeDoc={removeDoc}
                isCaseOpen={isCaseOpen}
                />
                <CaseDetailsInformation 
                caseDetails={caseDetails}
                additionalFields={additionalFields}
                setAdditionalFields={setAdditionalFields}
                setUpdateComp={setUpdateComp}
                uploadDocuments={uploadDocuments}
                removeDoc={removeDoc}
                isCaseOpen={isCaseOpen}
                />
                </>
                }
                </div>
                </>
               :
                <div className='bg-white w-full px-2  '>

                {
                    process.env.REACT_APP_AI_TOGGLE === "true" ?
                    <>
                    {(caseDetails?.aiPartyResearchStatus === 3 ||
                      caseDetails?.aiValuationStatus === 2 || caseDetails?.aiValuationStatus === 3 ||
                      caseDetails?.aiFirmMatchStatus === 2 || caseDetails?.aiFirmMatchStatus === 3) ?
                        <AiIntegration  caseDetails={caseDetails} setUpdateComp={setUpdateComp}/>
                        :
                        <AiInsightsLoading
                            stalled={insightsStalled}
                            onRetry={() => { setInsightsStalled(false); setUpdateComp((prev) => !prev); }}
                        />
                    }
                    </>
                    :
                    console.log("AI integration is disabled", process.env.REACT_APP_AI_TOGGLE)
                }
                
                
                </div>
            }
        </div>
        :
        (caseDetails?.is_deleted ? 
        <>
        <CaseDeletedModal uploadNew={true} onClose={() => navigate("/client/cases")}/>
        </>
        :
        <></>)
    }
    </>
        
  )
}

export default CaseBaseInfo